import "./contentStyles.scss";
import BgImg4 from "../../../../assets/application-section/22_MC-42142_2005 1.png";
import TwailaPicture from '../../../peoplepage/peoplePhotos/twiladale.jpg';
import ScienceLobby from '../../../../assets/application-section/ScienceLobby.jpg'

const Content = () => {
  return (
    <div className="content-wrapper">
      <header className="header-wrapper">
        <div className="header-content">
          <h1>Application Details</h1>
        </div>
      </header>
      <div className="step-1-container">
        <div className="content">
          <h2>Step 1: Apply to Ball State</h2>
          <p>Become a Cardinal by clicking this button: </p>
          <a target="_blank" href="https://www.bsu.edu/admissions/apply">
            <button>Apply to Ball State</button>
          </a>
        </div>
      </div>
      <div className="step-2-container">
        <div className="image-wrapper">
          <img src={BgImg4} alt="Ball State University Bell Tower" />
        </div>
        <div className="content">
          <h2>Step 2: Complete the FAFSA</h2>
          <p>Apply for Federal Aid by clicking this button: </p>
          <a
            target="_blank"
            href="https://www.bsu.edu/admissions/financial-aid-and-scholarships/financial-aid-process/fafsa"
          >
            <button>Complete the FAFSA</button>
          </a>
        </div>
      </div>
      <div className="step-3-container">
        <div className="top-image-wrapper">
          <img src={TwailaPicture} alt="Smiling Chemistry student" />
        </div>
        <div className="content-wrapper">
          <div className="content">
            <h2>Step 3: Complete the I-ASCEND Application</h2>
            <h3>What do you need to apply?</h3>
            <ol>
              <li>
                One{" "}
                <span style={{ fontStyle: "italic", fontWeight: 700 }}>
                  recommendation letter
                </span>
              </li>
              <li>
                <span style={{ fontWeight: "700", fontStyle: "italic" }}>
                  One-page essay
                </span>{" "}
                (450-500 words, double spaced) that includes
              </li>
              <ol type="a" className="m-bottom">
                <li>Why are you interested in chemistry or biology?</li>
                <li>
                  What career do you want to pursue with a chemistry or biology
                  degree?
                </li>
                <li>
                  Why are you interested in the I-ASCEND program (specifically,
                  describe how the program will help you achieve their goals,
                  other than providing scholarship support to offset financial
                  burden.)
                </li>
                <li>
                  Share any volunteer work, leadership experience,
                  extracurricular activities, awards, recognitions, employment
                  history/skills.
                </li>
                <li>
                  Share any challenges you have faced and how they have affected
                  your education and personal development.
                </li>
              </ol>
            </ol>

            <h3>Ready to Apply? Click Here: </h3>
            <a
              target="_blank"
              href="https://bsu.qualtrics.com/jfe/form/SV_6JPc8p3tGGM7ELc"
            >
              <button>Fill Out Application</button>
            </a>
            <p style={{width: '51dvw'}}><em>Applications for the 2025-2026 academic year are no longer being accepted.</em></p>
          </div>
        </div>
      </div>
      <div className="step-4-container">
        <div className="image-wrapper">
          <img src={ScienceLobby} alt="Chemistry student writing on whiteboard" />
        </div>
      </div>
    </div>
  );
};

export default Content;
